import {StyleSheet} from 'react-native';

import {codGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  tabBarTabText: {
    // Added it because when focusing tab which makes the title bold, the
    // size of the element does not change and part of the title is hidden
    width: '110%',
    fontSize: 14,
    color: codGray,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  tabBarBoldText: {
    fontWeight: '700',
  },
});
